module.exports = __webpack_public_path__ + "static/media/restart-button.d8441fae.gif";